import React from 'react';
export default function Underline(props) {
    return React.createElement("u", null, props.children);
}
//# sourceMappingURL=underline.js.map